var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWhiteLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0.54541C11.3976 0.54541 10.9092 1.03385 10.9092 1.63632V5.99996C10.9092 6.60243 11.3976 7.09086 12.0001 7.09086C12.6026 7.09086 13.091 6.60243 13.091 5.99996V1.63632C13.091 1.03385 12.6026 0.54541 12.0001 0.54541Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 19.0908C11.3976 19.0908 10.9092 19.5793 10.9092 20.1817V22.3635C10.9092 22.966 11.3976 23.4545 12.0001 23.4545C12.6026 23.4545 13.091 22.966 13.091 22.3635V20.1817C13.091 19.5793 12.6026 19.0908 12.0001 19.0908Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9091 11.4545H18.5455C17.943 11.4545 17.4546 11.9429 17.4546 12.5454C17.4546 13.1478 17.943 13.6363 18.5455 13.6363H22.9091C23.5116 13.6363 24 13.1478 24 12.5454C24 11.9429 23.5116 11.4545 22.9091 11.4545Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54545 12.5454C6.54545 11.9429 6.05702 11.4545 5.45455 11.4545H1.09091C0.488436 11.4545 0 11.9429 0 12.5454C0 13.1478 0.488436 13.6363 1.09091 13.6363H5.45455C6.05702 13.6363 6.54545 13.1478 6.54545 12.5454Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4855 4.06013C20.0595 3.63409 19.3688 3.63409 18.9427 4.06013L15.8571 7.14573C15.4311 7.57176 15.4311 8.26246 15.8571 8.68849C16.0701 8.90151 16.3493 9.00806 16.6285 9.00806C16.9077 9.00806 17.1869 8.90158 17.3999 8.68849L20.4855 5.60289C20.9115 5.17686 20.9115 4.48616 20.4855 4.06013Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60024 16.4024L3.51479 19.488C3.08882 19.914 3.08882 20.6047 3.51479 21.0308C3.7278 21.2438 4.007 21.3503 4.2862 21.3503C4.5654 21.3503 4.8446 21.2438 5.05762 21.0308L8.14315 17.9452C8.56911 17.5191 8.56911 16.8284 8.14315 16.4024C7.71704 15.9764 7.02635 15.9764 6.60024 16.4024Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0576 4.0601C4.63157 3.63406 3.94088 3.63414 3.51484 4.0601C3.0888 4.48614 3.0888 5.17683 3.51484 5.60286L6.60037 8.68846C6.81346 8.90148 7.09259 9.00803 7.37179 9.00803C7.65091 9.00803 7.93019 8.90148 8.14313 8.68854C8.56917 8.2625 8.56917 7.57181 8.14313 7.14577L5.0576 4.0601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWhiteLoader);
export default __webpack_public_path__ + "static/media/smallWhiteLoader.d7a704833368d881d197f0626da6e314.svg";
export { ForwardRef as ReactComponent };